module.exports = __webpack_public_path__ + "img/shield-logo-web-reversed.027ec04a.svg";